var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIosAnalytics = function SvgIosAnalytics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M403.1,108.9c-81.2-81.2-212.9-81.2-294.2,0s-81.2,212.9,0,294.2c81.2,81.2,212.9,81.2,294.2,0 C484.3,321.9,484.3,190.1,403.1,108.9z M121.2,121.2c74.3-74.3,195.3-74.3,269.6,0c38,38,56.5,88.1,55.7,138 c-2.9-4.7-23.1-35.2-52.5-35.2c-27.9,0-42.3,26.1-51.8,43.3c-1.4,2.6-2.8,5-4,7.1c-11.6,19.5-27.7,30.4-43.1,29.3 c-13.6-1-25.2-11.3-32.6-29.2c-9.3-22.4-29.6-46.5-53.7-49.9c-11.4-1.6-28.6,0.9-45.3,21.7c-3.3,4.1-7,9.5-11.2,15.9 c-10.6,15.7-26.5,39.4-38.7,41.4c-21,3.4-36.6-12.2-39.3-14.6c-2-1.7-4.4-4.3-7.2-7.5C59.5,224.5,77.5,164.8,121.2,121.2z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIosAnalytics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ios-analytics.59063126.svg";
export { ForwardRef as ReactComponent };